import { useContext } from "react";
import ActivityLogContext from "../contexts/activity-log-context";

export const useActivityLog = () => useContext(ActivityLogContext);
